export function fixMalformattedMessage(origMessageText: string) {
  return origMessageText.replaceAll(new RegExp("}(\\S)", "g"), "} $1").replaceAll(new RegExp("(\\S){", "g"), "$1 {");
}

//based on https://stackoverflow.com/questions/3942878/how-to-decide-font-color-in-white-or-black-depending-on-background-color
export function isColorDark(inputColor: string) {
  let colorToParse = standardizeColor(inputColor).substring(1, 7);
  let r = parseInt(colorToParse.substring(0, 2), 16); // hexToR
  let g = parseInt(colorToParse.substring(2, 4), 16); // hexToG
  let b = parseInt(colorToParse.substring(4, 6), 16); // hexToB
  return r * 0.299 + g * 0.587 + b * 0.114 <= 150;
}

//based on https://stackoverflow.com/questions/1573053/javascript-function-to-convert-color-names-to-hex-codes
function standardizeColor(inputColor: string) {
  var ctx = document.createElement("canvas").getContext("2d");
  if (!ctx) {
    return "#000000";
  }
  ctx.fillStyle = inputColor;
  return ctx.fillStyle;
}

export function stripWidthFromStyle(style: Object) {
  let clone = structuredClone(style);
  // @ts-ignore
  delete clone.width;
  return clone;
}

export function scrollSmoothTargetElmToCenterOfParentElm(parentElm: HTMLElement, targetElm: HTMLElement) {
  const parentElmHalfOfHeight = parentElm.offsetHeight / 2;
  const activeElmHalfOfHeight = targetElm.offsetHeight / 2;
  const finalScrollPosition = targetElm.offsetTop - parentElm.offsetTop - parentElmHalfOfHeight + activeElmHalfOfHeight;

  parentElm.scrollTo({
    top: finalScrollPosition,
    behavior: "smooth",
  });
}
